// import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

// import { NotificationsInterceptor } from './notifications.interceptor';

/**
 * Provides fakers implemented as interceptors
 *
 * Fakers are meant to be implemented when backend part is being developed and not ready yet. Once backend is ready,
 * faker should be simply commented out. Do not remove it as it might be useful in the future.
 *
 * Fakers are implemented in the outermost layer (i.e. as interceptors) so all other app parts can be developed like the
 * backend is already there.
 *
 * NOTE: This module SHOULD NOT be included for PROD environment (i.e. environment.production === true) no matter what.
 */
@NgModule({
  // comment and uncomment response fakers as needed but do not delete them
  providers: [
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: NotificationsInterceptor,
    //   multi: true,
    // },
  ],
})
export class ApiFakerModule {}
